function a(t) {
  for (var r = [], e; !(e = t.next()).done; )
    r.push(e.value);
  return r;
}
export {
  a as default
};
